/**
 * Global Script Reinitializer - Future-proof solution
 */
window.reinitializeAllScripts = function() {
  console.log('🔄 Reinitializing all scripts...');
 
  // 1. Reinitialize custom elements that may have lost their references
  const stickyCartBars = document.querySelectorAll('sticky-cart-bar');
  stickyCartBars.forEach(element => {
    // Force the custom element to reinitialize by calling init directly
    if (element.init && typeof element.init === 'function') {
      element.init();
    }
    // Alternative: trigger disconnectedCallback and connectedCallback
    else if (element.disconnectedCallback && element.connectedCallback) {
      element.disconnectedCallback();
      element.connectedCallback();
    }
  });

  // 2. Re-execute all script tags that contain initialization code
  document.querySelectorAll('#MainContent script:not([src])').forEach(script => {
    if (script.textContent.includes('DOMContentLoaded') || 
        script.textContent.includes('init') ||
        script.textContent.includes('setup')) {
      try {
        eval(script.textContent);
      } catch (e) {
        console.warn('Script re-execution failed:', e);
      }
    }
  });
  
  // 3. Trigger all common events
  ['DOMContentLoaded', 'load', 'resize'].forEach(eventType => {
    const event = eventType === 'DOMContentLoaded' 
      ? new Event(eventType) 
      : new Event(eventType, { bubbles: true });
    
    document.dispatchEvent(event);
    if (eventType === 'resize') {
      window.dispatchEvent(event);
    }
  });
  
  // 4. Trigger custom events
  ['product:loaded', 'scripts:reloaded', 'page:updated'].forEach(eventType => {
    document.dispatchEvent(new CustomEvent(eventType, { 
      bubbles: true,
      detail: { source: 'product-toggle' }
    }));
  });

  // 5. Force re-registration of custom elements if needed
  setTimeout(() => {
    // Check if sticky cart bar exists but isn't working
    const stickyBars = document.querySelectorAll('sticky-cart-bar');
    stickyBars.forEach(bar => {
      if (!bar.mainForm || !bar.intersectionObserver) {
        console.log('🔧 Force reinitializing sticky cart bar...');
        bar.init();
      }
    });
  }, 200);
  
  console.log('✅ Script reinitialization complete');
};

/**
 * Simplified Product Comparison Custom Element
 */
class ProductComparison extends HTMLElement {
  constructor() {
    super();
    this.switching = false;
    this.preloadedContent = {};
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.querySelectorAll('.product-comparison__item').forEach(item => {
      item.addEventListener('click', this.handleItemClick);
    });
    this.preloadProducts();
  }

  handleItemClick(e) {
    e.preventDefault();
    const targetHandle = e.currentTarget.dataset.productHandle;
    const currentHandle = this.getCurrentProductHandle();
    
    if (targetHandle && targetHandle !== currentHandle && !this.switching) {
      this.querySelectorAll('.product-comparison__item').forEach(c => 
        c.classList.remove('product-comparison__item--selected')
      );
      e.currentTarget.classList.add('product-comparison__item--selected');
      this.switchProduct(targetHandle);
    }
  }

  getCurrentProductHandle() {
    const pathname = window.location.pathname;
    if (pathname.includes('/products/')) {
      return pathname.split('/products/')[1].split('/')[0];
    }
    return null;
  }
async switchProduct(targetHandle) {
  if (this.switching) return;
  this.switching = true;
  
  try {
    let html = this.preloadedContent[targetHandle];
    if (!html) {
      const response = await fetch(`/products/${targetHandle}`);
      html = await response.text();
      this.preloadedContent[targetHandle] = html;
    }
    
    const newDoc = new DOMParser().parseFromString(html, 'text/html');
    document.body.innerHTML = newDoc.body.innerHTML;
    document.body.className = newDoc.body.className;
    document.title = newDoc.title;
history.pushState({}, newDoc.title, `/products/${targetHandle}`);

// Clear stale product data so old variant IDs aren't used
window.ShopifyProduct = null;

setTimeout(() => {
      window.reinitializeAllScripts();
      
      // Re-run the inventory interceptor since the body was replaced
      window.inventoryUpdateScriptLoaded = false; // Allow re-init
      if (typeof window.initInventoryUpdateScript === 'function') {
        window.initInventoryUpdateScript();
      }
      
      this.init();
    }, 100);
    
  } catch (error) {
    console.error('Switch failed:', error);
    window.location.href = `/products/${targetHandle}`;
  }
  
  this.switching = false;
}

  preloadProducts() {
    setTimeout(() => {
      this.querySelectorAll('.product-comparison__item').forEach(item => {
        const handle = item.dataset.productHandle;
        if (handle && !this.preloadedContent[handle]) {
          fetch(`/products/${handle}`)
            .then(response => response.text())
            .then(html => {
              this.preloadedContent[handle] = html;
            });
        }
      });
    }, 500);
  }
}

customElements.define('product-comparison', ProductComparison);